var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-tooltip",
    _vm._b(
      {
        scopedSlots: _vm._u(
          [
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  !_vm.noBtn
                    ? _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              on: {
                                click: function($event) {
                                  return _vm.$emit("click")
                                }
                              }
                            },
                            "v-btn",
                            _vm.$attrs,
                            false
                          ),
                          on
                        ),
                        [_vm._t("default")],
                        2
                      )
                    : _c(
                        "span",
                        [
                          !_vm.iconLoading
                            ? _vm._t("default", null, {
                                on: on,
                                loading: _vm.loading,
                                isLoading: _vm.iconLoading
                              })
                            : _vm._t(
                                "icon-loader",
                                function() {
                                  return [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        indeterminate: "",
                                        size: 20,
                                        width: 2,
                                        color: _vm.$attrs.color
                                      }
                                    })
                                  ]
                                },
                                {
                                  on: on,
                                  loading: _vm.loading,
                                  isLoading: _vm.iconLoading
                                }
                              )
                        ],
                        2
                      )
                ]
              }
            }
          ],
          null,
          true
        )
      },
      "v-tooltip",
      _vm.$attrs,
      false
    ),
    [_c("span", [_vm._v(_vm._s(_vm.tooltip))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }